module.exports = __webpack_public_path__ + "img/24600.330239ee.jpg";